var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgIconDownload15X = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "34px",
  height: "34px",
  viewBox: "0 0 34 34",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  ref: ref,
  "aria-labelledby": titleId
}, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, "827B34CF-8F59-4D9E-9E9F-8832117A88F6@1.5x") : title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "\\uD83D\\uDD27-Workspace",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Webplayer-Icons",
  transform: "translate(-46.000000, -143.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Icon-/-Download",
  transform: "translate(46.000000, 143.000000)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  fill: "#010B3B",
  cx: 17,
  cy: 17,
  r: 17
}), /*#__PURE__*/React.createElement("g", {
  id: "Icon-/-Default-/-Download",
  transform: "translate(17.000000, 16.000000) scale(1, -1) translate(-17.000000, -16.000000) translate(8.000000, 8.000000)",
  stroke: "#FFFFFF",
  strokeWidth: 1.5
}, /*#__PURE__*/React.createElement("g", {
  id: "Icon/Default/Share"
}, /*#__PURE__*/React.createElement("path", {
  d: "M18,0 C18,0.780487805 18,1.74113948 18,3.30211509 C18,4.16421812 17.3284271,4.8630907 16.5,4.8630907 L1.5,4.8630907 C0.671572875,4.8630907 0,4.16421812 0,3.30211509 C0,1.83450838 0,0.733803354 0,0",
  id: "Path",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  transform: "translate(9.000000, 2.431545) scale(1, -1) translate(-9.000000, -2.431545) "
}), /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(6.965217, 5.853659)"
}, /*#__PURE__*/React.createElement("line", {
  x1: 1.87826087,
  y1: 1.17073171,
  x2: 1.87826087,
  y2: 10.1463415,
  id: "Line-3",
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Triangle",
  fill: "#FFFFFF",
  strokeLinejoin: "round",
  transform: "translate(1.956522, 1.560976) rotate(-90.000000) translate(-1.956522, -1.560976) ",
  points: "3.51749735 1.56097561 0.395546129 3.51749735 0.395546129 -0.395546129"
})))))))));

const ForwardRef = /*#__PURE__*/forwardRef(SvgIconDownload15X);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Icon_Download@1.5x.58d1cc25cb899c31b7c3fd00ef95205c.svg";